import PropTypes from 'prop-types'
import { setDisconnectMessage, gracefulExit } from '../../actions/disconnect'
import { CLOSE_TIMEOUT } from '../../lib/WebRTC'

const stateProps = {
  'webrtcConnection.unstable': PropTypes.bool.isRequired,
}

/**
 * check if this modal should be displayed
 * @param {Object} state - the whole store state
 * @returns {Boolean} - true|false
 */
const shouldDisplay = ({
  webrtcConnection: { unstable },
}) => {
  return (Boolean(unstable))
}

let dispatch = null

const onDisconnect = () => {
  dispatch(setDisconnectMessage('disconnect-by-you'))
  dispatch(gracefulExit())
}

/**
 * returns the modal data; this function is called
 * by AppModal only when this modal should be displayed
 * @param {Object} state - store state
 * @param {Function} dispatch - store dispatch
 * @param {Function} translate - i18n.t
 *
 * @returns {Object} - the modal data to be rendered by AppModal
 */
const getModalData = ({ dispatch: dispatchFunc, translate }) => {
  dispatch = dispatchFunc
  return {
    iconClass: 'modal-icon-ondemand-connection-unstable',
    title: 'ovl-unstable-title',
    body: 'ovl-unstable-message',
    note: translate('connection-unstable-note', { seconds: CLOSE_TIMEOUT }),
    buttons: [{ text: 'btn-disconnect', onClick: onDisconnect }]
  }
}

export default {
  stateProps,
  shouldDisplay,
  getModalData,
}
